import React from "react";
import { RxCross2 } from "react-icons/rx";
import Button from "../ui/button";
import CancelButton from "../ui/cancelbutton";

export default function Modal({
  title,
  children,
  onClose,
  onSubmit,
  isProcessing = false,
  submitText = "Submit",
}) {
  return (
    <div
      className="fixed inset-0 z-50 overflow-y-auto"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div className="flex items-center justify-center min-h-screen px-4">
        {/* Overlay */}
        <div
          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          onClick={onClose}
        ></div>

        {/* Modal Content */}
        <div className="inline-block rounded-xl text-left overflow-hidden shadow-xl transform transition-all sm:my-auto sm:max-w-lg sm:w-full">
          {/* Header */}
          <div className="bg-gray-100 px-4 py-3 border-b border-gray-300 flex justify-between items-center">
            <h1 className="text-lg font-bold text-gray-900 flex items-center gap-2">
              <span className="inline-block w-1.5 h-6 bg-primary rounded-full"></span>
              {title}
            </h1>
            <button
              type="button"
              className="rounded-full p-1 hover:bg-gray-300 transition-colors"
              onClick={onClose}
              disabled={isProcessing}
            >
              <RxCross2 size={20} />
            </button>
          </div>

          {/* Body */}
          <form onSubmit={onSubmit}>
            <div className="bg-white px-4 pt-2 pb-4 sm:p-6 sm:pb-4 space-y-4">
              {children}
            </div>

            {/* Footer */}
            <div className="bg-gray-50 px-4 py-3 sm:px-6 gap-2 sm:flex sm:flex-row-reverse">
              <Button
                type="submit"
                disabled={isProcessing}
               className="w-full sm:w-auto"
              >
                {submitText}
              </Button>

              <CancelButton
                type="button"
                onClick={onClose}
                disabled={isProcessing}
                 className="w-full sm:w-auto"
              >
                Cancel
              </CancelButton>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
